import gql from 'graphql-tag'

import { UserFragment } from '../fragments'

const mutation = gql`
  mutation ClearNotification($id: String!) {
    clearNotification(id: $id) {
      errors {
        key
        message
      }
      currentUser {
        id
        ...User
      }
    }
  }
  ${UserFragment}
`

export default mutation
